module.exports = __webpack_public_path__ + "img/btn-enter2.9b03879b.png";